import { Avatar, Checkbox, Col, Typography, Button } from "antd";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { IProducts } from "../../../../redux/@types";
import { useProducts } from "../../../products";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { decimal } from "../../../../shared/utils/Helper";
import Table from "../../../../shared/components/ui/Table";
import { productsService } from "../../../../shared/services";
import { useAssignProductWharehouse } from "../../hooks/productWerehouses/useAssignProductWharehouse";
import { useParams } from "react-router-dom";
import { useProductWarehouses } from "../../hooks/productWerehouses/useProductWarehouses";
import React from "react";

const { Title } = Typography;

interface Props {
  fetchQuery?: any;
}

export const TableProducts = ({ fetchQuery }: Props) => {
  const { warehouse_id } = useParams();
  const { productWarehouseInfo, productWarehouses } = useProductWarehouses({
    warehouseId: +warehouse_id!,
  });
  const { assignProductWharehouse, removeProductWharehouse } =
    useAssignProductWharehouse();

  const [selectedProductIds, setSelectedProductIds] = React.useState<
    Set<number>
  >(new Set());

  React.useEffect(() => {
    const activeIds = new Set(
      productWarehouseInfo
        .filter((info) => info.status === "active")
        .map((info) => info.product_id)
    );
    setSelectedProductIds(activeIds);
  }, [productWarehouseInfo]);

  const handleSelect = (productId: number, checked: boolean) => {
    setSelectedProductIds((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (checked) {
        newSelected.add(productId);
      } else {
        newSelected.delete(productId);
      }
      return newSelected;
    });
  };

  const handleAssignProducts = async () => {
    const selectedProductsArray = Array.from(selectedProductIds);
    for (const productId of selectedProductsArray) {
      await assignProductWharehouse({
        productId: +productId,
        warehouseId: +warehouse_id!,
      });
    }
    await productWarehouses(); // Refresh the data after assigning
  };

  const handleRemoveProducts = async () => {
    const selectedProductsArray = Array.from(selectedProductIds);
    for (const productId of selectedProductsArray) {
      await removeProductWharehouse(+warehouse_id!, productId);
    }
    await productWarehouses(); // Refresh the data after removal
  };

  const { setTableProps } = useProducts();

  const columns: TableColumns<IProducts> = [
    {
      title: "Foto",
      width: 7,
      dataIndex: "media",
      key: "media",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            {item.media[0] && (
              <Avatar
                size={64}
                src={`${PATH_S3_BUCKET}/${item.media.sort(
                  (a, b) => b.priority - a.priority
                )[0]?.path!}`}
              />
            )}
          </Col>
        );
      },
    },
    {
      title: "Nombre",
      width: 12,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Código",
      width: 10,
      dataIndex: "code",
      key: "code",
      filterType: "text",
    },
    {
      title: "Categoría",
      width: 10,
      dataIndex: ["category", "name"],
      key: "category",
    },
    {
      title: "Precio",
      width: 10,
      dataIndex: "price",
      key: "price",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Title style={{ fontSize: "0.74rem", fontWeight: "500" }} level={5}>
              $ {decimal(item.price)}
            </Title>
          </Col>
        );
      },
    },
    {
      title: "Cantidad",
      width: 10,
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Asignar a la bodega",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        const isProductAssigned = selectedProductIds.has(item.id);

        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Checkbox
              checked={isProductAssigned}
              onChange={(e) => handleSelect(item.id, e.target.checked)}
            />{" "}
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={handleAssignProducts}
        disabled={selectedProductIds.size === 0}
        style={{ marginBottom: 16 }}
      >
        Asignar Productos
      </Button>
      <Button
        type="default"
        onClick={handleRemoveProducts}
        disabled={selectedProductIds.size === 0}
        style={{ marginBottom: 16, marginLeft: 8 }}
      >
        Desasignar Productos
      </Button>
      <Table<IProducts>
        columns={columns}
        scroll={{ y: 300 }}
        fetchQueryProps={{
          $sort: { id: -1 },
          ...fetchQuery,
        }}
        service={productsService}
        onLoad={setTableProps}
      />
    </>
  );
};
